/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const TextBulletedHierarchyIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Text Bulleted Hierarchy',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <rect height="6" rx="2.8" ry="2.8" width="6" x="4" y="2" />
    <rect height="6" rx="2.8" ry="2.8" width="6" x="12" y="14" />
    <rect height="6" rx="2.8" ry="2.8" width="6" x="12" y="26" />
    <rect height="4" rx="1" ry="1" width="14" x="20" y="28" />
    <rect height="4" rx="1" ry="1" width="14" x="20" y="16" />
    <rect height="4" rx="1" ry="1" width="22" x="12" y="4" />
  </svg>`;
};
